import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { OnInit } from 'cv-ng-metadata/core';
import { Subscription } from 'rxjs';
import { ChallengeBattleShipService, ShotStatus } from 'src/app/gamification/command-center/services/challenge-battle-ship.service';

@Component({
  selector: 'cv-battle-boat-shot',
  templateUrl: './battle-boat-shot.component.html',
  styleUrl: './battle-boat-shot.component.scss'
})
export class BattleBoatShotComponent implements OnInit, OnDestroy {
  
  @Input()
  challenge: any = null;
  lastShotStatus: ShotStatus = {
    status: 'unset',
    message: ''
  };

  private subscriptions = new Subscription();

  constructor(private challengeBattleBoatService: ChallengeBattleShipService) {
  }

  ngOnInit() {
    this.subscriptions.add(this.challengeBattleBoatService.lastShotStatus$.subscribe(lastShotStatus => {
      this.lastShotStatus = lastShotStatus;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
